import { AfterViewInit, Component, ViewChild, ViewContainerRef } from "@angular/core";
import { AgEditorComponent } from "ag-grid-angular";

@Component({
  selector: "ag-grid-checkbox-editor",
  template: `<div #container tabindex="0" (keydown)="onKeyDown($event)">
    <input type="checkbox" (click)="onClick($event)" [checked]="checked" />
  </div>`,
  standalone: false,
  styles: [
    `
      .mood {
        border-radius: 1px;
        border: 1px solid grey;
        background: #e6e6e6;
        padding: 5px;
        text-align: center;
        display: inline-block;
        outline: none;
      }

      .default {
        padding-left: 10px;
        padding-right: 10px;
        border: 1px solid transparent;
        padding: 4px;
      }

      .selected {
        padding-left: 10px;
        padding-right: 10px;
        border: 2px solid lightgreen;
        background: #e6e6e6;
        padding: 4px;
      }
    `,
  ],
})
export class CheckboxEditor implements AgEditorComponent, AfterViewInit {
  private params: any;

  @ViewChild("container", { read: ViewContainerRef }) public container;
  public checked: boolean = false;

  // dont use afterGuiAttached for post gui events - hook into ngAfterViewInit instead for this
  ngAfterViewInit() {
    window.setTimeout(() => {
      this.container.element.nativeElement.focus();
    });
  }

  agInit(params: any): void {
    this.params = params;
    this.setState(params.value);
  }

  getValue(): any {
    return this.checked ? true : false;
  }

  isPopup(): boolean {
    return false;
  }

  setState(value: boolean): void {
    this.checked = value;
  }

  toggleState(): void {
    this.setState(!this.checked);
  }

  onClick(event) {
    const checked = event.target.checked;
    this.setState(checked);
  }

  onKeyDown(event): void {
    let key = event.which || event.keyCode;
    if (String.fromCharCode(key) === "Y") {
      this.setState(true);
      event.stopPropagation();
    } else if (String.fromCharCode(key) === "N") {
      this.setState(false);
      event.stopPropagation();
    }
  }
}
